var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppMonitoringIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 205,
    viewBox: "0 0 375 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11072_39468)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.7523,
    y: 76.5774,
    width: 23.4502,
    height: 113.042,
    stroke: "url(#paint0_linear_11072_39468)",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.061,
    y: 113.857,
    width: 23.4502,
    height: 113.042,
    stroke: "url(#paint1_linear_11072_39468)",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.164,
    y: 113.857,
    width: 23.4502,
    height: 113.042,
    stroke: "url(#paint2_linear_11072_39468)",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.555,
    y: 53.4279,
    width: 24.0514,
    height: 136.492,
    fill: "url(#paint3_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.137 76.2767H93.0981C94.387 76.2767 95.4324 77.3205 95.4344 78.6093L95.5862 174.286H111.137V76.2767Z",
    fill: "url(#paint4_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.343 53.4279H189.304C190.593 53.4279 191.638 54.4717 191.64 55.7604L191.792 174.286H207.343V53.4279Z",
    fill: "url(#paint5_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M255.445 105.74H237.407C238.696 105.74 239.741 106.783 239.744 108.072L239.895 186.913H255.445V105.74Z",
    fill: "url(#paint6_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M303.548 105.74H285.51C286.799 105.74 287.844 106.783 287.847 108.072L287.998 186.913H303.548V105.74Z",
    fill: "url(#paint7_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M309.561 61.2446H291.522C292.812 61.2446 293.86 62.2872 293.865 63.5771L294.011 96.1192H309.561V61.2446Z",
    fill: "url(#paint8_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.149 31.7816H99.1108C100.401 31.7816 101.448 32.8242 101.454 34.1141L101.599 66.6562H117.149V31.7816Z",
    fill: "url(#paint9_linear_11072_39468)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.958,
    y: 53.7285,
    width: 23.4502,
    height: 135.891,
    stroke: "url(#paint10_linear_11072_39468)",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.863,
    y: 105.74,
    width: 24.0514,
    height: 7.81672,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 168.259,
    y: 126.183,
    width: 23.4502,
    height: 14.4309,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.76,
    y: 105.74,
    width: 24.0514,
    height: 13.8296,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.555,
    y: 45.6111,
    width: 24.0514,
    height: 19.2412,
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.657,
    y: 53.4279,
    width: 24.0514,
    height: 28.2605,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4517,
    y: 94.9166,
    width: 24.0514,
    height: 9.01929,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.786,
    cy: 55.833,
    r: 11.7251,
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.976 54.9311L226.884 58.8394L233.498 52.2253",
    stroke: "white",
    strokeWidth: 1.20257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.087 65.1529V104.838",
    stroke: "#4D4D4D",
    strokeWidth: 1.20257,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.6 6.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.7396,
    y: 30.8796,
    width: 35.4759,
    height: 35.4759,
    rx: 5.11093,
    stroke: "#4D4D4D",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4776,
    cy: 49.8202,
    r: 8.11736,
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.60772,
    cy: 3.60772,
    r: 3.30707,
    transform: "matrix(1 0 0 -1 90.0916 42.0034)",
    stroke: "#4D4D4D",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.151,
    y: 60.3427,
    width: 35.4759,
    height: 35.4759,
    rx: 5.11093,
    stroke: "#4D4D4D",
    strokeWidth: 0.601286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.484 79.4335V88.9037H269.275V67.2574M273.484 79.4335L269.275 67.2574M273.484 79.4335L277.225 88.9037H281.902M269.275 67.2574H273.484L277.225 76.878M281.902 88.9037V67.2574H277.225V76.878M281.902 88.9037L277.225 76.878",
    stroke: "black",
    strokeWidth: 0.601286
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11072_39468",
    x1: 83.4774,
    y1: 76.2767,
    x2: 83.4774,
    y2: 181.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11072_39468",
    x1: 227.786,
    y1: 113.556,
    x2: 227.786,
    y2: 182.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11072_39468",
    x1: 275.889,
    y1: 113.556,
    x2: 275.889,
    y2: 182.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11072_39468",
    x1: 131.58,
    y1: 53.4279,
    x2: 131.58,
    y2: 189.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11072_39468",
    x1: 87.3445,
    y1: 121.902,
    x2: 100.31,
    y2: 122.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11072_39468",
    x1: 183.55,
    y1: 109.69,
    x2: 196.53,
    y2: 110.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11072_39468",
    x1: 231.653,
    y1: 143.527,
    x2: 244.599,
    y2: 144.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11072_39468",
    x1: 279.756,
    y1: 143.527,
    x2: 292.702,
    y2: 144.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11072_39468",
    x1: 285.769,
    y1: 77.4793,
    x2: 298.448,
    y2: 79.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11072_39468",
    x1: 93.3572,
    y1: 48.0163,
    x2: 106.036,
    y2: 50.0575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11072_39468",
    x1: 179.683,
    y1: 53.4279,
    x2: 179.683,
    y2: 189.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11072_39468"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.514679,
    width: 374,
    height: 204.437,
    rx: 9.62058,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMonitoringIllustration);
export default __webpack_public_path__ + "static/media/appMonitoringIllustration.e1275613ed24cee738ae789624331221.svg";
export { ForwardRef as ReactComponent };